import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {of, ReplaySubject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  DictService, POST_TAG_TYPE_DEPARTMENT_TYPE,
  POST_TAG_TYPE_INSURANCE_COMPANY,
  POST_TAG_TYPE_POST_TYPE,
  POST_TAG_TYPE_REMAINING
} from "../../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {NgxImageCompressService} from "ngx-image-compress";
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {UserService} from "../../../../shared/services/user.service";
import * as uuid from 'uuid';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Tag} from "../../../../shared/interface/tag";
import {TagUsers} from "../../../../shared/interface/tag-users";
import {HttpErrorResponse} from "@angular/common/http";
import {TagService} from "../../../../shared/services/tag.service";
import {UsersDialogComponent} from "../../../../shared/components/users-dialog/users-dialog.component";
import {User} from "../../../../shared/interface/user";
import {validPhoneNumber} from "../../../../shared/validator/phone-validator";
import {validEmailAddress} from "../../../../shared/validator/email-validator";
import {FileManagerService} from "../../../../shared/services/file-manager.service";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {LicensedAgent} from "../../../../shared/interface/licensed-agent";
import {PageDetails, PageManager} from "../../../../shared/interface/page-manager";
import {Post} from "../../../../shared/interface/post";
import moment from "moment";
import {PostDetails} from "../../../../shared/interface/post-details";
import {Attachments} from "../../../../shared/interface/attachments";
import {FileManagerPageService} from "../../../../shared/services/file-manager-page.service";
import {co} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-add-page',
  templateUrl: './add-page.component.html',
  styleUrls: ['./add-page.component.scss']
})
export class AddPageComponent implements OnInit {
  @Input() maxSize = 1050000;
  @Input()  pageObject?: PageManager;
  @Output() closeModification = new EventEmitter<any>();

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '400px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść ...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['fontName', 'inline-block'],
      [
        'insertVideo',
        'insertImage',
        'insertHorizontalRule'
      ]
    ]
  };

  pageForm: FormGroup;
  nameControl: FormControl;
  pageDetails: FormGroup[] = [];
  permissionPartnerControl: FormControl;
  permissionOfwcaControl: FormControl;
  permissionTagPartnerControl: FormControl;
  permissionRegistrationListControl: FormControl;
  publishingDepartmentControl: FormControl;
  userFormArray: FormGroup[] = [];
  pageAdd = false;
  errors: any = {};
  initializeStart = false;

  readonly POST_TAG_TYPE_POST_TYPE = POST_TAG_TYPE_POST_TYPE;
   readonly POST_TAG_TYPE_DEPARTMENT_TYPE = POST_TAG_TYPE_DEPARTMENT_TYPE;
   readonly POST_TAG_TYPE_INSURANCE_COMPANY = POST_TAG_TYPE_INSURANCE_COMPANY;
   readonly POST_TAG_TYPE_REMAINING = POST_TAG_TYPE_REMAINING;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private uuid: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private imageCompress: NgxImageCompressService,
    private userService: UserService,
    private route: ActivatedRoute,
    private tagService: TagService,
    private fileManagerPageService: FileManagerPageService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.pageForm = fb.group({
      name: this.nameControl = this.fb.control('', [Validators.required]),
      pageDetails:  fb.array(this.pageDetails),
      permissionRegistrationList: this.permissionRegistrationListControl = this.fb.control([]),
      permissionPartner: this.permissionPartnerControl = this.fb.control(true),
      permissionOfwca: this.permissionOfwcaControl = this.fb.control(true),
      permissionTagPartner: this.permissionTagPartnerControl = this.fb.control([]),
      users: fb.array(this.userFormArray),
    });
    }


  ngOnInit(): void {
    if (this.pageObject) {
          this.initialize(this.pageObject);
    }

  }

  addPageDetails(pageDetailType: string,
                 pageDetailUuid?: string,
                 pageDetailCtaButton?: string,
                 pageDetailCtaLink?: string,
                 pageDetailCtaHeadline?: string,
                 pageDetailCtaText?: string,
                 pageDetailContent?: string,
                 pageDetailFilename?: string,
                 pageDetailFileLocation?: string,
                 pageDetailText?: string,
                 pageDetailIndex?: number,
                 pageTableColumn?: number,
                 pageDetailTextSecond?: string,
                 pageDetailTextThird?: string,
                 edit = true,
                 pageDetailMovieLink?: string,
  ): void {
    switch (pageDetailType) {
      case 'TEXT':
        this.pageDetails.push(this.fb.group({
          pageDetailUuid: this.fb.control(pageDetailUuid ?? uuid.v4(), [Validators.required]),
          pageDetailType: this.fb.control(pageDetailType, [Validators.required]),
          pageDetailText: this.fb.control(pageDetailText ?? ''),
          pageDetailIndex: this.fb.control(  pageDetailIndex ?? this.pageDetails.length ),
        }));
        break;
      case 'GRAPHICS':
        this.pageDetails.push(this.fb.group({
          pageDetailUuid: this.fb.control(pageDetailUuid ?? uuid.v4(), [Validators.required]),
          pageDetailType: this.fb.control(pageDetailType, [Validators.required]),
          pageDetailContent: this.fb.control(pageDetailContent ?? ''),
          pageDetailFilename: this.fb.control(pageDetailFilename ?? '', [Validators.required]),
          pageDetailFileLocation: this.fb.control(pageDetailFileLocation ?? ''),
          pageDetailIndex: this.fb.control(  pageDetailIndex ?? this.pageDetails.length ),
          edit: this.fb.control(false),
          pageDetailCtaLink: this.fb.control(pageDetailCtaLink ?? ''),
        }));
        break;
      case 'CTA':
        this.pageDetails.push(this.fb.group({
          pageDetailUuid: this.fb.control(pageDetailUuid ?? uuid.v4(), [Validators.required]),
          pageDetailType: this.fb.control(pageDetailType, [Validators.required]),
          pageDetailCtaButton: this.fb.control(pageDetailCtaButton ?? '', [Validators.required]),
          pageDetailCtaLink: this.fb.control(pageDetailCtaLink ?? '', [Validators.required]),
          pageDetailCtaHeadline: this.fb.control(pageDetailCtaHeadline ?? ''),
          pageDetailCtaText: this.fb.control(pageDetailCtaText ?? ''),
          pageDetailIndex: this.fb.control(  pageDetailIndex ?? this.pageDetails.length ),

        }));
        break;
      case 'TABLE':
        this.pageDetails.push(this.fb.group({
          pageDetailUuid: this.fb.control(pageDetailUuid ?? uuid.v4(), [Validators.required]),
          pageDetailIndex: this.fb.control(  pageDetailIndex ?? this.pageDetails.length ),
          pageDetailType: this.fb.control(pageDetailType, [Validators.required]),
          pageTableColumn: this.fb.control(pageTableColumn ?? 2),
          pageDetailText: this.fb.control(pageDetailText ?? ''),
          pageDetailTextSecond: this.fb.control(pageDetailTextSecond ?? ''),
          pageDetailTextThird: this.fb.control(pageDetailTextThird ?? ''),
        }));
        break;
      case 'MOVIE':
        this.pageDetails.push(this.fb.group({
          pageDetailUuid: this.fb.control(pageDetailUuid ?? uuid.v4(), [Validators.required]),
          pageDetailIndex: this.fb.control(  pageDetailIndex ?? this.pageDetails.length ),
          pageDetailType: this.fb.control(pageDetailType, [Validators.required]),
          pageDetailMovieLink: this.fb.control(pageDetailMovieLink ?? ''),
        }));
        break;
      default:
    }
    this.refreshPageDetailsControl();
  }

  drop(event: CdkDragDrop<any[]>) {
    this.pageDetails[event.previousIndex].get('pageDetailIndex').setValue(event.currentIndex);
    this.pageDetails[event.currentIndex].get('pageDetailIndex').setValue(event.previousIndex);
    moveItemInArray(this.pageDetails, event.previousIndex, event.currentIndex);
    this.refreshPageDetailsControl();
  }

  refreshPageDetailsControl(): void {
    this.pageForm.setControl('pageDetails', this.fb.array( this.pageDetails));
  }

  removePageDetailsControl(i: number): void {
    this.pageDetails.splice(i, 1);
    for ( let j = i; j < this.pageDetails.length; j++) {
      this.pageDetails[j].get('pageDetailIndex').setValue(this.pageDetails[j].get('pageDetailIndex').value - 1);
    }
    this.refreshPageDetailsControl();
  }

  onFileChange(event: any, index: number) {
    this.pageDetails[index].get('pageDetailContent').setValue(event['base64']);
    this.pageDetails[index].get('pageDetailFilename').setValue( event['filename']);
    this.pageDetails[index].get('edit').setValue( true);

  }

  sendForm(): void {

    this.updateUsersFormArray();
    this.pageAdd = true;
    const formData: any = {...this.pageForm.value};

    if (!this.pageForm.valid) {
      this.pageForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      this.pageAdd = false;
      return;
    }

    this.fileManagerPageService.sendPage(formData, this.pageObject?.uuid )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open( this.pageObject ? 'Pomyślnie zaktualizowano stronę' : 'Pomyślnie utworzono stronę', '', {
          duration: 2000,
        });
        this.pageAdd = false;
        if (!this.pageObject  ) {
          this.router.navigate(['/serwis-plikow/strona/', response.uuid]);
        } else {
          this.closeModification.emit();
        }
        // this.router.navigate(['../'], { relativeTo: this.route });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania strony wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.pageAdd = false;
      });
  }

  cancel(): void {
    if (!this.pageObject) {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.closeModification.emit();
    }
  }

  addUsers(dialog= false, usersUuid?: string, usersName?: string, usersPosition?: string, usersPhone?: string, usersEmail?: string): void {
    if (dialog){
      const dialogRef = this.dialog.open(UsersDialogComponent, {
        width: '500px',
        data: {text: 'Wybierz użytkownika: '},
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const exists = this.userFormArray.some((user: FormGroup) => user.get('usersUuid')?.value === result);

          if (exists) {
            this.snack.open('Wybrany użytkownik już jest dodany', '', {
              duration: 2000
            });
            this.updateUsersFormArray();
            return;
          }
          this.userService.get(result).subscribe((user: User) => {
            this.userFormArray.push(this.fb.group({
              usersUuid:  this.fb.control(user.uuid || '', [Validators.required]),
              usersName:  this.fb.control(user.firstName + ' ' + user.lastName || '', [Validators.required]),
              usersPosition:  this.fb.control(user.position || ''),
              usersPhone:  this.fb.control(user.phone || '', [Validators.required, validPhoneNumber()]),
              usersEmail:  this.fb.control(user.email || '', [Validators.required, validEmailAddress()]),
            }));
          }, (error: HttpErrorResponse) => {
            this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
              duration: 2000
            });
          });
        }
      });
    } else {
      const exists = this.userFormArray.some((user: FormGroup) => user.get('usersUuid')?.value === usersUuid);

      if (exists) {
        // this.snack.open('Wybrany użytkownik już jest dodany', '', {
        //   duration: 2000
        // });
        this.updateUsersFormArray();
        return;
      }
      this.userFormArray.push(this.fb.group({
        usersUuid: this.fb.control(usersUuid || '', [Validators.required]),
        usersName:  this.fb.control(usersName || '', [Validators.required]),
        usersPosition:  this.fb.control(usersPosition || ''),
        usersPhone:  this.fb.control(usersPhone || '', [Validators.required, validPhoneNumber()]),
        usersEmail: this.fb.control(usersEmail || '', [Validators.required,  validEmailAddress()]),
      }));
    }
    this.updateUsersFormArray();
  }

  updateUsersFormArray(): void {
    this.pageForm.setControl('users', this.fb.array( this.userFormArray));
  }

  removeUsers(index: number): void {
    this.userFormArray.splice(index, 1);
    this.updateUsersFormArray();
  }

  initialize(page: PageManager): void {
    of(page)
      .pipe(
        delay(0),
        tap(() => {
          this.initializeStart = true;
          this.pageForm.reset({
            name: page.name,
            permissionRegistrationList: page.permissionRegistrationList,
            permissionPartner: page.permissionPartner,
            permissionOfwca: page.permissionOfwca,
            permissionTagPartner: page.permissionTagPartner,
          });
          page.pageDetails.sort(  (a, b) => a.pageDetailIndex - b.pageDetailIndex );


          page.pageDetails.forEach((details: PageDetails) => this.addPageDetails(
            details.pageDetailType, details.pageDetailUuid, details.pageDetailCtaButton, details.pageDetailCtaLink,
            details.pageDetailCtaHeadline, details.pageDetailCtaText, null, details.pageDetailFilename,
            details.pageDetailFileLocation, details.pageDetailText, details.pageDetailIndex, details.pageTableColumn,
            details.pageDetailTextSecond,  details.pageDetailTextThird, false, details.pageDetailMovieLink),
          );

        if (page.users) {
          page.users
            .forEach((user: TagUsers) => {
              this.addUsers(false, user.usersUuid, user.usersName,
                user.usersPosition, user.usersPhone, user.usersEmail);
            });
        }


        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

}
